import { EnemyType } from '@/types/enums';
import { EnemyConfig } from './type';

export const ENEMY_TYPES: Record<EnemyType, EnemyConfig> = {
  // ============ BASIC ENEMIES ============
  [EnemyType.BASIC]: {
    color: '#e94560',
    radius: 15,
    speed: 90,
    hp: 20,
    contactDamage: 15,
    xpValue: 10,
    goldValue: 2,
  },
  [EnemyType.FAST]: {
    color: '#ff8c00',
    radius: 10,
    speed: 210,
    hp: 10,
    contactDamage: 8,
    xpValue: 15,
    goldValue: 4,
  },
  [EnemyType.TANK]: {
    color: '#9b59b6',
    radius: 28,
    speed: 42,
    hp: 100,
    contactDamage: 35,
    xpValue: 35,
    goldValue: 9,
    canShoot: true,
    fireRate: 6000,
    bulletSpeed: 180,
    bulletDamage: 15,
    attackPatterns: ['single'],
  },
  [EnemyType.SWARM]: {
    color: '#2ecc71',
    radius: 7,
    speed: 132,
    hp: 5,
    contactDamage: 5,
    xpValue: 5,
    goldValue: 1,
  },

  // ============ ADVANCED ENEMIES ============
  [EnemyType.SPRINTER]: {
    color: '#00ffff',
    radius: 9,
    speed: 300,
    hp: 8,
    contactDamage: 12,
    xpValue: 20,
    goldValue: 5,
  },
  [EnemyType.BRUTE]: {
    color: '#8b0000',
    radius: 35,
    speed: 30,
    hp: 200,
    contactDamage: 50,
    xpValue: 60,
    goldValue: 15,
    canShoot: true,
    fireRate: 4000,
    bulletSpeed: 180,
    bulletDamage: 20,
    attackPatterns: ['single'],
  },
  [EnemyType.GHOST]: {
    color: 'rgba(255, 255, 255, 0.6)',
    radius: 14,
    speed: 120,
    hp: 15,
    contactDamage: 20,
    xpValue: 25,
    goldValue: 6,
    phasing: true,
  },
  [EnemyType.EXPLODER]: {
    color: '#ffff00',
    radius: 12,
    speed: 108,
    hp: 25,
    contactDamage: 5,
    xpValue: 20,
    goldValue: 5,
    explodeOnDeath: true,
    explosionRadius: 60,
    explosionDamage: 15,
  },
  [EnemyType.ZIGZAG]: {
    color: '#ff69b4',
    radius: 11,
    speed: 150,
    hp: 18,
    contactDamage: 8,
    xpValue: 18,
    goldValue: 4,
    zigzag: true,
  },
  [EnemyType.SPLITTER]: {
    color: '#7cfc00',
    radius: 20,
    speed: 72,
    hp: 40,
    contactDamage: 12,
    xpValue: 25,
    goldValue: 7,
    splitOnDeath: true,
    splitCount: 3,
  },
  [EnemyType.STOMPER]: {
    color: '#D2691E',
    radius: 18,
    speed: 55,
    hp: 60,
    contactDamage: 20,
    xpValue: 30,
    goldValue: 8,
    canShoot: true,
    fireRate: 4500,
    bulletSpeed: 0,
    bulletDamage: 12,
    attackPatterns: ['shockwave'],
  },

  // ============ BOSSES ============
  [EnemyType.BOSS]: {
    color: '#ff0000',
    radius: 50,
    speed: 30,
    hp: 750,
    contactDamage: 50,
    xpValue: 200,
    goldValue: 50,
    isBoss: true,
    canShoot: true,
    fireRate: 1300,
    bulletSpeed: 240,
    bulletDamage: 20,
    attackPatterns: ['single', 'double', 'spread'],
  },
  [EnemyType.BOSS_SWARM]: {
    color: '#00ff00',
    radius: 45,
    speed: 48,
    hp: 600,
    contactDamage: 30,
    xpValue: 250,
    goldValue: 60,
    isBoss: true,
    splitOnDeath: true,
    splitCount: 8,
    canShoot: true,
    fireRate: 1000,
    bulletSpeed: 300,
    bulletDamage: 10,
    attackPatterns: ['single', 'around', 'spread'],
  },
  [EnemyType.BOSS_TANK]: {
    color: '#8b00ff',
    radius: 65,
    speed: 18,
    hp: 1500,
    contactDamage: 80,
    xpValue: 300,
    goldValue: 75,
    isBoss: true,
    canShoot: true,
    fireRate: 2000,
    bulletSpeed: 180,
    bulletDamage: 35,
    attackPatterns: ['single', 'double', 'shockwave'],
  },
  [EnemyType.BOSS_SPEED]: {
    color: '#00ffff',
    radius: 40,
    speed: 96,
    hp: 500,
    contactDamage: 35,
    xpValue: 220,
    goldValue: 55,
    isBoss: true,
    zigzag: true,
    canShoot: true,
    fireRate: 550,
    bulletSpeed: 420,
    bulletDamage: 12,
    attackPatterns: ['single', 'spread'],
  },
  [EnemyType.BOSS_EXPLODER]: {
    color: '#ffff00',
    radius: 55,
    speed: 30,
    hp: 900,
    contactDamage: 40,
    xpValue: 280,
    goldValue: 70,
    isBoss: true,
    explodeOnDeath: true,
    explosionRadius: 150,
    explosionDamage: 50,
    canShoot: true,
    fireRate: 1600,
    bulletSpeed: 240,
    bulletDamage: 25,
    attackPatterns: ['spread', 'around', 'shockwave'],
  },
  [EnemyType.BOSS_GHOST]: {
    color: 'rgba(255, 255, 255, 0.7)',
    radius: 48,
    speed: 42,
    hp: 700,
    contactDamage: 45,
    xpValue: 260,
    goldValue: 65,
    isBoss: true,
    phasing: true,
    canShoot: true,
    fireRate: 1200,
    bulletSpeed: 300,
    bulletDamage: 18,
    attackPatterns: ['single', 'double', 'spread', 'around'],
  },
} as const;
